import React from 'react'

import MagicLinkEmailPasswordForm from './MagicLinkEmailPasswordForm'

function Login() {
  return <MagicLinkEmailPasswordForm type="login" />
}

export default Login
